module.exports = __webpack_public_path__ + "291da6734701c14d84f4ab3cfbb7c8ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/formFactors/cube.png
// module id = 1642
// module chunks = 5